<template>
  <div ref="logContainer" v-html="formattedLogs" class="log-container" :style="containerStyle"></div>
</template>

<script>
import AnsiToHtml from 'ansi-to-html';

export default {
  props: {
    logs: {
      type: String,
      required: true
    },
    height: {
      type: String,
      default: '300px'
    }
  },
  watch: {
    logs() {
      this.$nextTick(() => {
        const container = this.$refs.logContainer;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    }
  },
  computed: {
    formattedLogs() {
      const ansiToHtml = new AnsiToHtml();
      return ansiToHtml.toHtml(this.logs).replace(/\n/g, '<br>');
    },
    containerStyle() {
      return { maxHeight: this.height };
    }
  }
};
</script>

<style scoped>
.log-container {
  font-family: monospace;
  background: #000;
  color: #fff;
  white-space: pre-wrap;
  padding: 10px;
  border-radius: 5px;
  overflow-y: auto;
}
</style>